var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m89.2 21-9.3-9.3c-1.2-1.2-3.1-1.2-4.2 0l-40.5 40.4c-.2.2-.4.5-.6.8l-8.2 17.5c-.5 1.1-.3 2.5.6 3.4.6.6 1.3.9 2.1.9.4 0 .9-.1 1.3-.3l17.5-8.2c.3-.1.6-.3.8-.6l40.5-40.5c.6-.6.9-1.3.9-2.1s-.3-1.5-.9-2zm-44.4 40.1-9.5 4.5 4.5-9.5 28.9-28.9 5.1 5.1zm33.1-33.1-5.1-5.1 4.9-4.9 5.1 5.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m80.8 45.2c-1.7 0-3 1.3-3 3v1.6 31.5h-59.2v-59.5h6.4 2.8 27.4c1.7 0 3-1.3 3-3s-1.3-3-3-3h-27.4-2.8-6.4c-3.3 0-6 2.7-6 6v59.5c0 3.3 2.7 6 6 6h59.2c3.3 0 6-2.7 6-6v-11.9-19.6-1.6c0-1.6-1.4-3-3-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.26b352ac4894858623c3045fb7f72708.svg";
export { ForwardRef as ReactComponent };